import { connect } from "react-redux";
import CouponRedemptionLimit_View from "./CouponRedemptionLimit_View";
import { CouponRedemptionLimitActions } from "./CouponRedemptionLimitConstants";

const mapStateToProps = (state) => {
  // if you later add a reducer, map saved values here
  return {
    limitFromStore:
      (state.CouponRedemptionLimitReducer &&
        state.CouponRedemptionLimitReducer.limitType) ||
      "",
    freqFromStore:
      (state.CouponRedemptionLimitReducer &&
        state.CouponRedemptionLimitReducer.frequency) ||
      "",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setRedemptionLimit: (payload) => {
      dispatch({ type: CouponRedemptionLimitActions.Set.NAME, payload });
    },
    resetRedemptionLimit: () => {
      dispatch({ type: CouponRedemptionLimitActions.Reset.NAME });
    },
  };
};

const CouponRedemptionLimitContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CouponRedemptionLimit_View);

export default CouponRedemptionLimitContainer;